import React from 'react';
import { Card, Loading, Tag, Toast, ProgressBar } from 'antd-mobile';
import { CalendarOutline, TextOutline, CheckOutline } from 'antd-mobile-icons';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { mobileApi } from '../api';
import { T, cardStyle, statusTag } from '../theme';

function TestPage() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery(
    'goszadanieGoTasks',
    () => mobileApi.goszadanieGoTasks(),
    {
      onError: () => Toast.show({ icon: 'fail', content: 'Не удалось загрузить задания' }),
    }
  );

  const tasks = data?.data || [];

  return (
    <div>
      <div style={{ fontSize: 20, fontWeight: 700, color: T.text, margin: '4px 2px 14px' }}>
        Госзадание GO
      </div>
      {isLoading ? (
        <Loading style={{ display: 'block', margin: '20px auto' }} />
      ) : tasks.length === 0 ? (
        <Card style={{ ...cardStyle, textAlign: 'center', color: T.hint }}>
          Заданий по кодам работ пока нет
        </Card>
      ) : (
        tasks.map((task) => {
          const codes = task.work_codes || [];
          const doneCount = codes.filter((c) => c.done).length;
          const cancelledCount = codes.filter((c) => c.cancelled).length;
          const total = codes.length;
          const allDone = total > 0 && doneCount + cancelledCount === total;
          const accent =
            task.status === 'completed'
              ? T.success
              : task.status === 'cancelled'
              ? T.danger
              : null;
          return (
            <Card
              key={task.id}
              style={{
                ...cardStyle,
                marginBottom: 14,
                cursor: 'pointer',
                ...(accent ? { borderLeft: `4px solid ${accent}` } : {}),
              }}
              onClick={() => navigate(`/test/${task.id}`)}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    fontSize: 13,
                    color: T.label,
                  }}
                >
                  <CalendarOutline style={{ fontSize: 14 }} />
                  {task.task_date ? dayjs(task.task_date).format('DD.MM.YYYY') : 'Дата не указана'}
                </div>
                {statusTag(task.status)}
              </div>

              <div
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: T.text,
                  lineHeight: 1.35,
                  marginTop: 8,
                }}
              >
                {task.address || 'Адрес не указан'}
              </div>

              {total > 0 && (
                <div style={{ marginTop: 10 }}>
                  {codes.map((c, idx) => (
                    <Tag
                      key={idx}
                      color={c.cancelled ? 'danger' : c.done ? 'success' : 'primary'}
                      style={{
                        marginRight: 6,
                        marginBottom: 4,
                        fontSize: 13,
                        padding: '3px 10px',
                        borderRadius: 8,
                      }}
                    >
                      {c.code}
                    </Tag>
                  ))}
                </div>
              )}

              {total > 0 && (
                <div style={{ marginTop: 8 }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: 6,
                    }}
                  >
                    <span style={{ fontSize: 12, color: T.label }}>
                      Выполнено {doneCount} из {total}
                      {cancelledCount > 0 && ` · отменено: ${cancelledCount}`}
                    </span>
                    {allDone && (
                      <span
                        style={{
                          fontSize: 12,
                          color: T.success,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 3,
                        }}
                      >
                        <CheckOutline /> Все коды закрыты
                      </span>
                    )}
                  </div>
                  <ProgressBar
                    percent={Math.round(((doneCount + cancelledCount) / total) * 100)}
                    style={{
                      '--track-width': '4px',
                      '--fill-color': allDone ? T.success : T.primary,
                    }}
                  />
                </div>
              )}

              {task.comment && (
                <div
                  style={{
                    display: 'flex',
                    gap: 6,
                    marginTop: 10,
                    fontSize: 13,
                    color: T.label,
                  }}
                >
                  <TextOutline style={{ fontSize: 14, flexShrink: 0, marginTop: 1 }} />
                  <span>{task.comment}</span>
                </div>
              )}
              {task.status === 'completed' && task.completed_by && (
                <div style={{ fontSize: 12, color: T.hint, marginTop: 8 }}>
                  Выполнил: {task.completed_by}
                  {task.completed_at && ` · ${dayjs(task.completed_at).format('DD.MM.YYYY HH:mm')}`}
                </div>
              )}
            </Card>
          );
        })
      )}
    </div>
  );
}

export default TestPage;
